<template>
    <MainContent
        title="Detalles del subscritor"
        format="card"
    >
        <template v-slot:header>
            <h3 class="card-title pt-2">Detalles del subscriptor</h3>
        </template>
        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab active title="Detalles">
                                <ContentOrLoading>
                                    <InformacionTab
                                        v-if="subscriptor"
                                        :subscriptor="subscriptor"
                                    />
                                </ContentOrLoading>
                            </b-tab>
                            <b-tab title="Grupos">
                                <ContentOrLoading>
                                    <GruposTab
                                        v-if="subscriptor"
                                        :subscriptor="subscriptor"
                                    />
                                </ContentOrLoading>
                            </b-tab>
                        </b-tabs>
                    </b-card>                    
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import InformacionTab from '@/components/backend/campana-emails/subscriptores/detalle/tabs/InformacionTab.vue';
    import GruposTab from '../../../../components/backend/campana-emails/subscriptores/detalle/tabs/GruposTab.vue';

    export default {
        name: 'DetalleSubscriptor',
        props: {
            subscriptor_id: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                subscriptor: null,
                loading: false
            };
        },
        methods: {
            getSubscriptor() {
                try {
                    this.loading = true;
                    apiService.getSubscriptor(this.subscriptor_id).then(response => {
                        this.subscriptor = response.data;
                    }).catch(error => {
                        console.error("Error fetching subscriptor:", error);
                    }).finally(() => {
                        this.loading = false;
                    });
                } catch (error) {
                    console.error("Error in getSubscriptor method:", error);
                }
            },
        },
        mounted() {
            this.getSubscriptor();
        },
        components: {
            MainContent, InformacionTab, GruposTab
        }
    }
</script>